module.exports = __webpack_public_path__ + "img/doorWall.3cb55d8d.jpg";